import { useAuth } from '../../context/useAuth';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface LogoutProps {
  className?: string;
}

const Logout: React.FC<LogoutProps> = ({ className }) => {
  const { signOut } = useAuth();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      await signOut();
      // Navigate to login page with signedOut parameter
      navigate('/login?signedOut=true', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleLogout}
      disabled={isLoading}
      className={`text-red-600 hover:text-red-800 ${className || ''}`}
    >
      {isLoading ? 'Signing out...' : 'Sign out'}
    </button>
  );
};

export default Logout; 